export default __webpack_public_path__ + "static/media/landing-3-steps.f900b643.png";